import {
  type HistoryOptions,
  parseAsArrayOf,
  parseAsString,
  useQueryState,
} from '@vrplatform/query-params';
import { isUUID } from '@vrplatform/utils';
import { useCallback, useMemo } from 'react';
import { removeDrawerStateFromUrl } from '../utils';

export const resultParamKey = 'workflowIds'; // string[]

export const useSyncDetailDrawer = () => {
  const [sIds, setSyncIds] = useQueryState(
    resultParamKey,
    parseAsArrayOf(parseAsString)
  );

  const syncIds = useMemo(() => {
    return sIds?.filter((id) => isUUID(id || 'x')) ?? [];
  }, [sIds]);

  const activeDrawer = useMemo<'workflows' | undefined>(() => {
    if (syncIds?.length) return 'workflows';
    return undefined;
  }, [syncIds]);

  const closeDrawer = useCallback(() => {
    setSyncIds(null);
  }, [setSyncIds]);

  const setSyncs = useCallback(
    (
      syncIds: string[] | string,
      options?: {
        type?: HistoryOptions;
      }
    ) => {
      removeDrawerStateFromUrl();

      const ids = Array.isArray(syncIds) ? syncIds : [syncIds];
      setSyncIds(ids, { history: options?.type || 'push' });
    },
    [setSyncIds]
  );

  return {
    activeDrawer,
    close: closeDrawer,
    syncIds,
    open: setSyncs,
  };
};
